import { getSecondsInUnit } from './units';
export default function getStepDenominator(step) {
  // `factor` is a legacy property.
  if (step.factor !== undefined) {
    return step.factor;
  } // "unit" is now called "formatAs".


  return getSecondsInUnit(step.unit || step.formatAs) || 1;
}
//# sourceMappingURL=getStepDenominator.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/javascript-time-ago/modules/steps/getStepDenominator.js
// module id = 820
// module chunks = 0